import { AuthPort } from './auth-port';

/** Comportamiento de hoy: no hace nada. La identidad sigue viajando por `buildLocalHeaders()`. */
export class SimuladaAuth implements AuthPort {
  iniciar(): void {}

  async cerrarSesion(): Promise<void> {}
}
